import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ArchivoConEstado } from '../components/modal-subir-pdf/modal-subir-pdf.component';

@Injectable({
  providedIn: 'root'
})
export class EnvioMailService {
  private apiUrl = ``;
  private entity = `envio-mail`;

  constructor(private http: HttpClient) {

    if (environment.production)
      this.apiUrl = environment.apiUrl + this.entity;
    else
      this.apiUrl = environment.apiUrlDev + this.entity;

  }

  enviarArchivoConError(archivoConError: ArchivoConEstado) {
    const formData = new FormData();
    formData.append('file', archivoConError.file, archivoConError.file.name);
    formData.append('errorMessage', archivoConError.errorMessage || '');
    formData.append('procesando', archivoConError.procesando.toString());
    formData.append('completado', archivoConError.completado.toString());
    formData.append('error', archivoConError.error.toString());

    return this.http.post<any>(`${this.apiUrl}/archivo-error`, formData).pipe(
      map((response:any) => response) 
    );
  }
}
